export const isFreshworksWidgetAvailable = () => {
    return typeof FreshworksWidget === 'function';
};

export const getCommonCustomFields = (userProfileData) => {
    return {
        cf_terminal: userProfileData?.terminal?.code || '',
        cf_webmobile: 'IB Planning',
        cf_customer: window.location?.href?.split("//")[1]?.split(".")?.[0].toUpperCase() || ''
    };
};

export const updateFreshDesk = (userProfileData) => {
    if (isFreshworksWidgetAvailable()) {
        // Using user name as email since keycloack return email as userName 
        FreshworksWidget('identify', 'ticketForm', {
            name: userProfileData.userName,
        });
        FreshworksWidget('prefill', 'ticketForm', {
            custom_fields: getCommonCustomFields(userProfileData)
        });

        FreshworksWidget('disable', 'ticketForm', ['name'])
        FreshworksWidget('hide', 'ticketForm', ['custom_fields.cf_terminal', 'custom_fields.cf_webmobile', 'custom_fields.cf_customer']);
    }
}